<template>
  <div>
    <mt-header :title="$t('修改密码')" fixed class="dl_header_white">
      <mt-button icon="back" slot="left" @click="$router.back()"></mt-button>
    </mt-header>
    <div class="content">
      <div class="address">
        <input
          type="password"
          :placeholder="$t('旧密码')"
          class="wx_one_ellipsis wx_fontSize3"
          v-model="old_password"
        />
      </div>
      <div class="address">
        <input
          type="password"
          :placeholder="$t('新密码')"
          class="wx_one_ellipsis wx_fontSize3"
          v-model="password"
        />
      </div>
      <div class="address">
        <input
          type="password"
          :placeholder="$t('请确认新密码')"
          class="wx_one_ellipsis wx_fontSize3"
          v-model="confirm_password"
        />
      </div>
      <div class="footer wx_fontSize3" @click="onSubmit()">
        {{ $t("立即修改") }}
      </div>
    </div>
    <VerifyPopup
      ref="refVerify"
      scene="credentials_change_password"
      @onVerify="changePwd"
    />
  </div>
</template>

<script>
import VerifyPopup from "@/components/VerifyPopup";
import { httpChangePassword } from "@/api/index";
import { validatePwd } from "@/utils/validate";
import { Toast } from "mint-ui";
export default {
  components: { VerifyPopup },
  data() {
    return {
      old_password: "",
      password: "",
      confirm_password: "",
      noNeedVerify: false,
      credentials: null,
    };
  },
  activated() {
    this.old_password = "";
    this.password = "";
    this.confirm_password = "";
  },
  methods: {
    // 立即修改密码事件
    onSubmit() {
      if (!this.old_password || !this.password || !this.confirm_password) {
        Toast(this.$t("请填写完整表单"));
        return;
      }
      if (this.password !== this.confirm_password) {
        Toast(this.$t("两次密码不一致"));
        return;
      }
      if (!validatePwd(this.password)) {
        Toast(this.$t("wrongpwd"));
        return;
      }

      if (this.credentials) {
        this.changePwd(this.credentials);
      } else {
        this.$refs.refVerify.show = true;
      }
    },
    changePwd(credentials) {
      this.credentials = credentials;
      const payload = {
        old_password: this.old_password,
        password: this.password,
        confirm_password: this.confirm_password,
      };
      if (parseInt(Date.now() / 1000) > credentials.expiretime) {
        this.$refs.refVerify.show = true;
        return false;
      } else {
        payload.credentials = credentials.credentials;
      }
      httpChangePassword(payload).then((result) => {
        Toast(result.msg);
        //修改密码成功推出登录  后台会同步清空上线账号
        this.$store.dispatch("removeToken");
        this.$router.replace("/login");
      });
    },
  },
};
</script>

<style scoped>
.mint-header {
  background: transparent;
  color: #212529;
  border-bottom: 1px solid #e3e8ed;
}
.mint-button--default {
  color: #656b79 !important;
}

.content {
  padding: 0 15px;
  padding-top: 40px;
}
.address {
  height: 75px;
  line-height: 75px;
  border-bottom: 1px solid #e3e8ed;
  width: 100%;
  color: #a9afc8;
  position: relative;
}
.address.s2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.address input {
  width: 60%;
  height: 75px;
  line-height: 75px;
}
.contact {
  height: 26px;
  position: absolute;
  right: 0px;
  bottom: 20px;
  line-height: 26px;
  color: #212529;
}
.mark {
  width: 30px;
  height: 30px;
  position: relative;
  top: -8px;
}
.back {
  width: 7px;
  height: 12px;
  top: 0;
  margin-left: 14px;
  top: -16px;
}
.footer {
  width: 100%;
  height: 50px;
  background: #1296db;
  line-height: 50px;
  text-align: center;
  color: #ffffff;
  margin-top: 40px;
  border-radius: 4px;
}
</style>
